module.exports = __webpack_public_path__ + "static/media/icon_documents.1bd41dc2.png";